<template>
  <div
    class="h-screen p-8 gap-16 flex flex-col"
    :style="{
      background: `linear-gradient(167.65deg, white 60%, #fff1dd 100%)`
    }"
  >
    <div
      class="gap-4 flex items-center text-xl cursor-pointer"
      @click="handleGoBack"
    >
      <BaseIcon icon="angle-left" />
      <span>{{ $t('profile.back') }}</span>
    </div>

    <div class="gap-8 flex flex-col">
      <span class="text-3xl/10 font-bold">
        {{ $t('profile.welcome.title', { name: user.name }) }}
        <span class="text-primary">{{ $t('profile.welcome.personal') }}</span>
        {{ $t('profile.welcome.cabinet') }}
      </span>

      <span class="text-lg">
        {{ $t('profile.description') }}
      </span>
    </div>

    <div
      class="gap-4 flex items-center text-xl text-error cursor-pointer"
      @click="handleLogout"
    >
      <BaseIcon icon="sign-out-alt" />
      <span>{{ $t('profile.logout') }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TheProfile',

  computed: {
    ...mapState('user', ['user'])
  },

  methods: {
    ...mapActions('auth', {
      logout: 'LOGOUT'
    }),

    handleGoBack() {
      const isCanGoBack = window.history.length > 1

      if (isCanGoBack) {
        this.$router.back()
      } else {
        this.$router.push({ name: 'home' })
      }
    },

    handleLogout() {
      this.logout()
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
